import BackgroundWrapper from "@fuse/sharedComponents/backgroundWrapper"
import BlurWrapper from "@fuse/sharedComponents/blurWrapper"
import SolidBtn from "@fuse/sharedComponents/buttons/SolidBtn"
import LoadingSpinnerInline from "@fuse/sharedComponents/loader/LoadingSpinnerInline"

import {
  DownloadLinkMap,
  onOpenDownloadLink,
  useDeviceDetection,
} from "@fuse/utils/DeviceDection"

import { VERIFY } from "@fuse/pages/emailVerification/constant"
import { useVerify } from "@fuse/pages/emailVerification/useVerify"

import ConfettiBall from "@fuse/assets/gif/gif-confetti-ball.gif"
import Grimacing from "@fuse/assets/gif/gif-grimacing.gif"

const bgImage = "/assets/alpha-event-not-found.svg"

export const VerifyEmail = () => {
  const { verificationStatus } = useVerify()
  const device = useDeviceDetection()
  const downloadLink = DownloadLinkMap[device]

  const SuccessScreen = () => {
    return (
      <div className="flex flex-col justify-center items-center max-w-[422px]">
        <img className="w-28" src={ConfettiBall} />
        <div className="mt-6 text-[32px] font-semibold text-white">
          {VERIFY.EMAIL.TEXTS.SUCCESS.HEADING}
        </div>
        <div className="mt-4 text-white/35">
          {VERIFY.EMAIL.TEXTS.SUCCESS.SUBHEADING}
        </div>
        <div className="mt-4 text-white/35">
          {VERIFY.EMAIL.TEXTS.SUCCESS.BODY}
        </div>
      </div>
    )
  }

  const FailureScreen = () => {
    return (
      <div className="flex flex-col justify-center items-center max-w-[518px]">
        <img className="w-28" src={Grimacing} />
        <div className="mt-6 text-[32px] font-semibold text-white">
          {VERIFY.EMAIL.TEXTS.FAILURE.HEADING}
        </div>
        <div className="mt-4 text-white/35">
          {VERIFY.EMAIL.TEXTS.FAILURE.SUBHEADING}
        </div>
        <div className="mt-4 text-white/35">
          {VERIFY.EMAIL.TEXTS.FAILURE.BODY}
        </div>
      </div>
    )
  }

  const LoadingScreen = () => {
    return (
      <div className="flex flex-col justify-center items-center ">
        <div className="relative z-[10]">{<LoadingSpinnerInline />}</div>
        <div className="mt-6 text-[32px] mb-10 text-white">
          {VERIFY.EMAIL.TEXTS.LOADING.HEADING}
        </div>
      </div>
    )
  }

  const VerificationStatusScreen = () => {
    switch (verificationStatus) {
      case VERIFY.EMAIL.VERIFICATION_SUCCESS:
        return <SuccessScreen />
      case VERIFY.EMAIL.VERIFICATION_FAILED:
        return <FailureScreen />
      default:
        return <LoadingScreen />
    }
  }
  return (
    <BackgroundWrapper bgImage={bgImage} className="min-h-screen">
      <BlurWrapper
        overlayOpacityDefault="75"
        overlayColorDefault="dark"
        className="min-h-screen items-center justify-center flex"
      >
        <VerificationStatusScreen />
      </BlurWrapper>
    </BackgroundWrapper>
  )
}

const styles = {
  container: {
    background: `url(/assets/bg-gradient.svg)`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
}
